
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ShortFormattedDate from '../../../shared/ShortFormattedDate';

import './FineDateFields.scss';

const renderDateField = (name, date) => {
  if (date) {
    return (
      <div className="fine-date-field">
        <FormattedMessage
          id={`fines_date_field_${name}`}
          values={{ date: <ShortFormattedDate value={date} /> }} />
      </div>
    );
  }

  return null;
};

export default function FineDateFields({ fine }) {
  const checkedOutDate = fine.get('checkedOutDate');
  const dueDate = fine.get('dueDate');
  const returnedDate = fine.get('returnedDate');
  const renewedDate = fine.get('renewedDate');

  const anyDatePresent = checkedOutDate || dueDate || returnedDate || renewedDate;

  if (anyDatePresent) {
    return (
      <div className="cp-fine-date-fields">
        {renderDateField('checked_out', checkedOutDate)}
        {renderDateField('due', dueDate)}
        {renderDateField('returned', returnedDate)}
        {renderDateField('renewed', renewedDate)}
      </div>
    );
  }

  return null;
}

FineDateFields.propTypes = {
  fine: ImmutablePropTypes.map
};



// WEBPACK FOOTER //
// ./app/components/borrowing/fines/FineDateFields/FineDateFields.jsx